import { render, staticRenderFns } from "./WorkerInformation.vue?vue&type=template&id=44caef36&scoped=true"
import script from "./WorkerInformation.vue?vue&type=script&lang=js"
export * from "./WorkerInformation.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=44caef36&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44caef36",
  null
  
)

export default component.exports